// Bulk templete format
export const downloadExcelHeaderNameForTrolleyMaster = {
	'PLANT ID': '',
	'SHOP ID': '',
	'TROLLEY NAME': '',
	'SEQUENCING ORDER': '',
	'PART FAMILY NAME': '',
	'VEHICLE SETS': '',
	'PARTS PER VEHICLE SET': '',
	'TROLLEY TYPE': '',
};

// Regular expression
export const Regex = {
	name: /^[A-Za-z][A-Za-z\s]*$/,
	domain_name: /^[A-Za-z\d.]+$/,
	excel: /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/,
	excelDataString: /\r\n|\n/,
	skip_reason: /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
	part_family: /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
	part_description: /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
	part_identification: /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
	trolley_name: /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
	part_position: /^[0-9]*$/,
	quantity_required: /^[0-9]*$/,
	part_per_vehicle_set: /^[0-9]*$/,
	Vehicle_sets: /^[0-9]*$/,
	parts_per_pocket: /^[0-9]*$/,
	vc_no: /^[a-zA-Z0-9]*$/,
	part_no: /^[a-zA-Z0-9]*$/,
	station_no: /^[0-9]*$/,
	cost_no: /^[0-9.]*$/,
	remark: /^[\s\S]+$/,
	full_name: /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
	email_id: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
	vendor_code: /^[A-Za-z\d]+$/,
	buyer_code: /^[A-Za-z\d.-]+$/,
	mobile_no: /^[0-9]*\d{10}$/,
};
// Button constants
export const constants = {
	BUTTON_ATOMIC_COMPONENT: {
		PRIMARY: 'primary',
		SECONDARY: 'secondary',
		TERTIARY: 'tertiary',
		OKBUTTON: 'okButton',
		BULKDATA: 'Bulk data',
		DELETE: 'Delete',
		UPLOAD_IMAGE: 'Upload Image',
		REGENERATE: 'Regenerate Sequence',
		FEEDBACKS: 'Feedbacks',
	},
};

// constants are used for download funtionality

export const strategiesColumnName = {
	part_no: 'Part No.',
	receiving_location: 'TML Receiving Plant',
	company_name: 'Supplier Name',
	supplier: 'Supplier Location',
	recommended_date: 'Date',
	approval_status: 'Approval Status',
};

export const feedbackModalConstants = {
	part_no: 'Part No: ',
};

export const dateColumns = [
	'vin_generation_time',
	'vin_completion_time',
	'updated_at',
	'created_at',
];

export const keyOrderforpackaging_strategy = [
	'plant_id',
	'part_no',
	'vendor_code',
	'supplier_name',
	'approval_status',
	'dmp_approval_status',
	'dmp_buyer_status_evaluated_by',
	'dmp_buyer_status_evaluated_at',
	'scm_approval_status',
	'scm_buyer_status_evaluated_by',
	'scm_buyer_status_evaluated_at',
	'logistics_approval_status',
	'logistics_buyer_status_evaluated_by',
	'logistics_buyer_status_evaluated_at',
	'receiving_location',
	'part_description',
	'inco_terms',
	'models_applicable',
	'annual_volume',
	'supplier_packaging_cost',
	'supplier_transport_cost',
	'part_per_vehicle',
	'part_weight',
	'part_dimension_length',
	'updated_at',
	'updated_by',
	'created_at',
	'created_by',
];

export const userheaderMappings = {
	plant_name: 'PLANT NAME',
	user_role: 'USER ROLE',
	buyer_code: 'BUYER CODE',
	full_name: 'FULL NAME',
	domain_name: 'DOMAIN NAME',
	email_id: 'EMAIL ID',
	vendor_code: 'VENDOR CODE',
	mobile_no: 'MOBILE NO',
	commodity_type_name: 'COMMODITY TYPE NAME',
	is_admin_access_modified: 'ADMIN ACCESS',
	updated_at: 'UPDATED AT',
	updated_by: 'UPDATED BY',
	created_at: 'CREATED AT',
	created_by: 'CREATED BY',
};

export const keyOrderforUser = [
	'plant_name',
	'user_role_name',
	'full_name',
	'domain_name',
	'email_id',
	'vendor_code',
	'buyer_code',
	'mobile_no',
	'commodity_type_name',
	'is_admin_access_modified',
	'updated_at',
	'updated_by',
	'created_at',
	'created_by',
];

export const plasticPackagingRecyclingGuidelines = [
	['Category', '2024-25', '2025-26', '2026-27', '2027-28 and Onwards'], // Headers
	['I (Rigid)', '50', '60', '70', '80'], // Data Row 1
	['II (Flexible)', '30', '40', '50', '60'], // Data Row 2
	['III (Multilayered)', '30', '40', '50', '60'], // Data Row 3
	['IV (Compostable)', '50', '40', '70', '80'], // Data Row 3
];

export const recycledContentGuidelines = [
	['Category', '2024-25', '2025-26', '2026-27', '2027-28 and Onwards'], // Headers
	['I (Rigid)', '30', '40', '50', '60'], // Data Row 1
	['II (Flexible)', '10', '10', '20', '20'], // Data Row 2
	['III (Multilayered)', '5', '5', '10', '10'], // Data Row 3
];

export const uploadLimit = 2000;

export const complyingOptions = [
	{ label: 'Yes', value: 'Yes' },
	{ label: 'No', value: 'No' },
];

export const fieldHeadings = {
	part_only_image: 'Part Only Image',
	part_dunnage_primary_packaging_image: 'Primary Packaging Image',
	primary_plus_secondary_packaging_image: 'Primary + Secondary Packaging Image'
};

export const tataLogoBase64 =
	'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';